import { CheckCircle, WarningCircle } from "phosphor-react";
import { DriverAddressInformation } from "../../../models/api/admin/driverDetails";
import { TableCellData, TableHeader } from "../Table";
import { AllowedColumnIdsRecord } from "../../../models/app/admin/driver";
import { DriverListOrderByOptions } from "../../../models/api/admin/driver";
export const driverAddressTableAllowedIdsEn = {
    postcode: "postCode",
    addressMatch: "addressMatch",
} as const satisfies AllowedColumnIdsRecord;

export type DriverAddressTableAllowedIds =
    (typeof driverAddressTableAllowedIdsEn)[keyof typeof driverAddressTableAllowedIdsEn];

export const driverAddressTableHeaders: TableHeader<DriverAddressTableAllowedIds>[] =
    [
        {
            title: "Postcode",
            id: "postCode",
            hide: true,
            orderBy: DriverListOrderByOptions.AddressPostcode,
            menuGroup: "Address",
        },
        {
            title: "Address match",
            id: "addressMatch",
            hide: true,
            menuGroup: "Address",
        },
    ];

export const driverAddressTableContent = (
    address: DriverAddressInformation
): TableCellData<DriverAddressTableAllowedIds>[] => [
    {
        id: "postCode",
        content: <p>{address.postCode ?? "-"}</p>,
    },
    {
        id: "addressMatch",
        content: (
            <>
                {!address.addressMatch && address.addressMatch != null ? (
                    <div className="flex flex-row items-start gap-2">
                        <WarningCircle
                            className="text-S2D-error-40"
                            weight="bold"
                            size={20}
                        />
                        <p>Address mismatch</p>
                    </div>
                ) : (
                    <div className="flex flex-row items-start gap-2">
                        <CheckCircle
                            className="text-S2D-success-80 brightness-90"
                            weight="bold"
                            size={20}
                        />
                        <p>Address match</p>
                    </div>
                )}
            </>
        ),
    },
];
